export enum MenuAction {
  // basic
  Referral = 'Referral',
  View = 'View',
  Edit = 'Edit',
  Review = 'Review',
  KIP = 'Kip',

  // PWN / Re‑eval PWN
  SendPwn = 'Send PWN',
  SendReevalPwn = 'Send Reeval PWN',
  EditReevalPwn = 'Edit Reeval PWN',
  ViewReevalPwn = 'View Reeval PWN',
  AddReferral = 'Add Referral',
  ViewPWN = 'View PWN',
  EditPWN = 'Edit PWN',

  // SHM / Social‑History‑Meeting
  ScheduleShm = 'Schedule SHM',
  ScheduleSocialHistoryMeeting = 'Schedule Social History Meeting',
  RescheduleShm = 'Reschedule SHM',
  ViewShm = 'View SHM',
  ViewSocialHistoryMeeting = 'View Social History Meeting',
  RescheduleSocialHistoryMeeting = 'Reschedule Social History Meeting',

  // Gen‑Ed Intervention meetings
  ScheduleGenEdInterventionMeeting = 'Schedule Gen Ed Interv Meeting',
  RescheduleGenEdInterventionMeeting = 'Reschedule Gen Ed Interv Meeting',

  // Withdrawal / Agreements
  WithdrawParentPrincipalAgreement = 'Withdraw Parent/Principal Written Agreement',
  Withdraw = 'Withdraw',

  // Misc requests & events
  CreateRequestToSharePersonallyIdentifiableInformation = 'Create Request to Share Personally Identifiable Information',
  EditRequestToSharePersonallyIdentifiableInformation = 'Edit Request to Share Personally Identifiable Information',
  ViewRequestToSharePersonallyIdentifiableInformation = 'View Request to Share Personally Identifiable Information',
  RequestToSharePersonallyIdentifiableInformation = 'Request to Share Personally Identifiable Information',
  EiTransition = 'eitransition',
  RequestReupload = 'Request Re-Upload',
  RequestNewDocument = 'Request New Document',
  LogOutreachEvent = 'Log Outreach Event',

  // Evaluations & SHP
  Evaluations = 'evaluations',
  EditShp = 'Edit SHP',
  AssessmentPlanning = 'Assessment Planning',
  Evaluation = 'Evaluation',
  EditSocialHistoryPackage = 'Edit Social History Package',
  ViewSocialHistoryPackage = 'View Social History Package',

  // PWN – Additional Assessments
  SendPwnAdditionalAssessments = 'Send PWN: Request for Additional Assessments',
  EditPwnAdditionalAssessments = 'Edit PWN: Request for Additional Assessments',
  ReviewPwnAdditionalAssessments = 'Review PWN: Request for Additional Assessments',
  ViewPwnAdditionalAssessments = 'View PWN: Request for Additional Assessments',

  // Pre‑School Summary
  CreatePreschoolSummary = 'Create Pre School Summary',
  ViewPreschoolSummary = 'View Pre School Summary',
  EditPreschoolSummary = 'Edit Pre School Summary',

  // Meetings (generic)
  CancelMeetings = 'Cancel Meetings',
  ScheduleMeeting = 'Schedule Meeting',
  RescheduleMeeting = 'Reschedule Meeting',

  // Requests & notices
  CloseRequest = 'Close Request',
  CreateFinalNoticeWithdrawalEval = 'Create Final Notice of Withdrawal from the Eval',
  EditFinalNoticeWithdrawalEval = 'Edit Final Notice of Withdrawal from the Eval',
  ViewFinalNoticeWithdrawalEval = 'View Final Notice of Withdrawal from the Eval',

  RemoveFromMDEWorklist = 'Remove from MDE Worklist',

  // Nested evals
  EvaluationsNested = 'evaluationsNested',

  // Extension workflow
  RequestExtension = 'Request for Extension',
  ReviewRequestExtension = 'Review Request for Extension',
  CreateExtensionRequest = 'Create an Extension Request',
  ReviewExtensionRequest = 'Review Extension Request',
  ViewExtensionRequest = 'View Extension Request',

  // Assessments
  ReviewAssessment = 'Review Assessment',
  ViewAssessment = 'View Assessment',
  SubmitSTAC = 'Submit STAC5',
  ApproveSTACDocument = 'Approve STAC Document',
  EditTeacherOTChecklist = 'Edit Teacher OT Checklist',
  ViewTeacherOTChecklist = 'View Teacher OT Checklist',
  EditPTTeacherChecklist = 'Edit PT Teacher Checklist',
  ViewPTTeacherChecklist = 'View PT Teacher Checklist',
  EditParentOTChecklist = 'Edit Parent OT Checklist',
  ViewParentOTChecklist = 'View Parent OT Checklist',
  EditPTParentChecklist = 'Edit PT Parent Checklist',
  ViewPTParentChecklist = 'View PT Parent Checklist',

  ScheduleEvaluationMeeting = 'Schedule Evaluation Meeting',
  RescheduleEvaluationMeeting = 'Reschedule Evaluation Meeting',

  // IEP documents
  Iep = 'iep',
  IEP = 'IEP',
  CreateIepDocument = 'Create IEP Document',
  CreateIep = 'Create IEP',
  EditIepDocument = 'Edit IEP Document',
  ViewIepDocument = 'View IEP Document',
  AmendIEP = 'Amend IEP',

  // Assurance checklist
  CreateAssuranceChecklist = 'Create Assurance Checklist',
  EditAssuranceChecklist = 'Edit Assurance Checklist',
  ViewAssuranceChecklist = 'View Assurance Checklist',

  // LRE forms
  CreateLreForm = 'Create LRE Form',
  EditLreForm = 'Edit LRE Form',
  ViewLreForm = 'View LRE Form',

  // Ineligibility
  CreateIneligibilityDocument = 'Create Ineligibility Document',
  ViewIneligibilityDocument = 'View Ineligibility Document',
  ViewIneligibility = 'View InEligibility',

  // Waiver of meeting
  CreateWaiverOfIepMeeting = 'Create Waiver of IEP Meeting',
  ViewWaiverOfIepMeeting = 'View Waiver of IEP Meeting',

  // Declassification
  ViewDeclassification = 'View Declassification',
  CreateDeclassification = 'Create Declassification',
  EditDeclassification = 'Edit Declassification',

  // Meetings
  ScheduleIepMeeting = 'Schedule IEP Meeting',
  RescheduleIepMeeting = 'Reschedule IEP Meeting',
  ViewNoticeOfIEPMeeting = 'View Notice of IEP Meeting',
  ViewIEPMeeting = 'View IEP Meeting',
  ReconveneIEPMeeting = 'Reconvene IEP Meeting',
  CreateAnnualIEPMeeting = 'Create Annual IEP Meeting',

  // 12‑Month School‑Year Consent
  CreateTwelveMonthSchoolYearConsentForm = 'Create 12 Month School Year Consent Form',
  EditTwelveMonthSchoolYearConsentForm = 'Edit 12 Month School Year Consent Form',
  ViewTwelveMonthSchoolYearConsentForm = 'View 12 Month School Year Consent Form',

  // Educational Benefit Review
  CreateEdBenefitReview = 'Create Ed. Benefit Review',
  EditEdBenefitReview = 'Edit Ed. Benefit Review',
  ViewEdBenefitReview = 'View Ed. Benefit Review',

  // PWN (Notice of Recommendation)
  SendPwnNoticeOfRecommendation = 'Send PWN (Notice of Recommendation)',
  ViewPwnNoticeOfRecommendation = 'View PWN (Notice of Recommendation)',
  EditPwnNoticeOfRecommendation = 'Edit PWN (Notice of Recommendation)',

  // PWN recommendations linked to other flows
  ViewDeclassificationPwnRecommendation = 'View Declassification PWN Recommendation',
  EditDeclassificationPwnRecommendation = 'Edit Declassification PWN Recommendation',
  ViewIneligibilityPwnRecommendation = 'View InEligibility PWN Recommendation',
  EditIneligibilityPwnRecommendation = 'Edit InEligibility PWN Recommendation',
  CaptureFirstAttendDate = 'Capture First Attend Date',
  AnnualReviewIEP = 'Annual Review IEP',
  CreateProgressReport = 'Create Progress Report',
  EditProgressReport = 'Edit Progress Report',

  SendPWNDeclassification = 'Send PWN (Declassification)',
  EditPWNDeclassification = 'Edit PWN (Declassification)',
  ViewPWNDeclassification = 'View PWN (Declassification)',
  SendPWNIneligibility = 'Send PWN (Ineligibility)',
  EditPWNIneligibility = 'Edit PWN (Ineligibility)',
  ViewPWNIneligibility = 'View PWN (Ineligibility)',

  CbstDashboard = 'cbstdashboard',

  ViewCentralResponse = 'View Central Response',
  ViewLre = 'View LRE',

  Placement = 'Placement',

  CreateConsentInitialProvisionServices = 'Create Consent for Initial Provision of Services',
  EditConsentInitialProvisionServices = 'Edit Consent for Initial Provision of Services',
  ViewConsentInitialProvisionServices = 'View Consent for Initial Provision of Services',

  CreateConsentInitialProvisionServicesParentallyPlaced = 'Create Consent for Initial Provision of Services/Parentally Placed',
  EditConsentInitialProvisionServicesParentallyPlaced = 'Edit Consent for Initial Provision of Services/Parentally Placed',
  ViewConsentInitialProvisionServicesParentallyPlaced = 'View Consent for Initial Provision of Services/Parentally Placed',

  CreateConsentServicesDeferredPlacement = 'Create Consent for Services/ Deferred Placement',
  EditConsentServicesDeferredPlacement = 'Edit Consent for Services/ Deferred Placement',
  ViewConsentServicesDeferredPlacement = 'View Consent for Services/ Deferred Placement',

  CreateConsentDep1 = 'Create Consent for DEP-1',
  EditConsentDep1 = 'Edit Consent for DEP-1',
  ViewConsentDep1 = 'View Consent for DEP-1',

  CreateConsentParentNoticeIntentParentallyPlaced = 'Create Consent for Parent Notice of Intent/Parentally Placed',
  EditConsentParentNoticeIntentParentallyPlaced = 'Edit Consent for Parent Notice of Intent/Parentally Placed',
  ViewConsentParentNoticeIntentParentallyPlaced = 'View Consent for Parent Notice of Intent/Parentally Placed',

  CreateConsentShareInformationParentallyPlaced = 'Create Consent for Share Information/Parentally Placed',
  EditConsentShareInformationParentallyPlaced = 'Edit Consent for Share Information/Parentally Placed',
  ViewConsentShareInformationParentallyPlaced = 'View Consent for Share Information/Parentally Placed',

  CreateRequestToShareInformationParentallyPlaced = 'Create Request to Share Information/Parentally Placed',
  EditRequestToShareInformationParentallyPlaced = 'Edit Request to Share Information/Parentally Placed',
  ViewRequestToShareInformationParentallyPlaced = 'View Request to Share Information/Parentally Placed',

  CreateConsentExtendedSchoolYearParentSurvey = 'Create Consent for Extended School Year Parent Survey',
  EditConsentExtendedSchoolYearParentSurvey = 'Edit Consent for Extended School Year Parent Survey',
  ViewConsentExtendedSchoolYearParentSurvey = 'View Consent for Extended School Year Parent Survey',

  CreateConsentC7P = 'Create Consent for C7P',
  EditConsentC7P = 'Edit Consent for C7P',
  ViewConsentC7P = 'View Consent for C7P',

  GenerateParentNotificationforCollegeAccommodationsLetter = 'Generate Parent Notification for College Accommodations Letter',
  ViewParentNotificationforCollegeAccommodationsLetter = 'View Parent Notification for College Accommodations Letter',
  // ──────────────────────────────── OUTREACHES ──────────────────────────────
  CreateSchoolPlacementRequest = 'Create School Placement Request',
  EditSchoolPlacementRequest = 'Edit School Placement Request',
  ViewSchoolPlacementRequest = 'View School Placement Request',

  CreateStudentExitSummary = 'Create Student Exit Summary',
  EditStudentExitSummary = 'Edit Student Exit Summary',
  ViewStudentExitSummary = 'View Student Exit Summary',

  CreateAuthorizationToAttendLetter = 'Create Authorization to Attend Letter',
  EditAuthorizationToAttendLetter = 'Edit Authorization to Attend Letter',
  ViewAuthorizationToAttendLetter = 'View Authorization to Attend Letter',

  CreateP1Package = 'Create P-1',
  EditP1Package = 'Edit P-1',
  ViewP1Package = 'View P-1',

  CreateAuthorizationIepNoChange = 'Create Authorization of the IEP - No Change',
  EditAuthorizationIepNoChange = 'Edit Authorization of the IEP - No Change',
  ViewAuthorizationIepNoChange = 'View Authorization of the IEP - No Change',

  CreateAuthorizationIepChange = 'Create Authorization of the IEP - Change',
  EditAuthorizationIepChange = 'Edit Authorization of the IEP - Change',
  ViewAuthorizationIepChange = 'View Authorization of the IEP - Change',

  CreateFinalNoticeRecommendation = 'Create Final Notice of Recommendation',
  EditFinalNoticeRecommendation = 'Edit Final Notice of Recommendation',
  ViewFinalNoticeRecommendation = 'View Final Notice of Recommendation',

  // ──────────────────────── CONSENT – OTHER FORMS ───────────────────────────
  CreateParentWithdrawalOfConsent = 'Create Parent Withdrawal of Consent',
  EditParentWithdrawalOfConsent = 'Edit Parent Withdrawal of Consent',
  ViewParentWithdrawalOfConsent = 'View Parent Withdrawal of Consent',

  CreateNoticeOfTermination = 'Create the Parent Revocation - Notice of Termination',
  EditNoticeOfTermination = 'Edit Notice of Termination',
  ViewNoticeOfTermination = 'View Notice of Termination',

  // ──────────────────────────────── PWN FORMS ───────────────────────────────
  CreatePriorNoticePlacementWithdrawal = 'Create Prior Notice for Placement Withdrawal',
  EditPriorNoticePlacementWithdrawal = 'Edit Prior Notice for Placement Withdrawal',
  ViewPriorNoticePlacementWithdrawal = 'View Prior Notice for Placement Withdrawal',

  // ──────────────────────── PLACEMENT UTILITIES & CLOSE ─────────────────────
  RescindPlacement = 'Rescind Placement',
  LaunchTenMonthPlacementFinder = 'Launch 10-Month Placement Finder',
  LaunchSummerPlacementFinder = 'Launch Summer Placement Finder',
  CaseClose = 'Case Close',

  EventLog = 'eventlog',
  ViewUserEvent = 'View User Event',
  EditUserEvent = 'Edit User Event',
  DeleteUserEvent = 'Delete User Event',

  Student = 'Student',
  Upload = 'Upload',
  Reassign = 'Reassign',
  Assign = 'Assign',

  //KIP
  CreateChildOutcomesSummary = 'Create Child Outcome Summary',
  EditChildOutcomesSummary = 'Edit Child Outcome Summary',
  ViewChildOutcomesSummary = 'View Child Outcome Summary',



  //RelatedServices
  relatedServices = 'Related Services',
  CreateIEPAcknowledgmentForm = 'Create IEP Acknowledgment Form',
  EditIEPAcknowledgmentForm = 'Edit IEP Acknowledgment Form',
  ViewIEPAcknowledgmentForm = 'View IEP Acknowledgment Form',
  DeleteIEPAcknowledgmentForm = 'Delete IEP Acknowledgment Form',

  EnterReasonForDelay = 'Enter Reason for Delay',
  Miscellaneous = 'Miscellaneous',
  CaptureFirstAttendDateAndAuthorizationDate = 'Capture First Attend and Authorization Date',

  AssistiveTechnologyAssessment = 'Create AT Referral',
  EditAssistiveTechnologyAssessment = 'Edit AT Referral',
  ViewAssistiveTechnologyAssessment = 'View AT Referral',
  ReviewAssistiveTechnologyAssessment = 'Review AT Referral',
}
